import React from 'react';
import { IconProps } from '../types';

const AudioWaveLoadingIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      {/* Bar 1 - starts at full height, shrinks to center, expands back */}
      <rect x="2" y="2" width="2" height="20" fill={color}>
        <animate
          attributeName="height"
          values="20;0;20"
          dur="1.5s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          values="2;12;2"
          dur="1.5s"
          repeatCount="indefinite"
        />
      </rect>

      {/* Bar 2 - animates after bar 1 */}
      <rect x="6" y="4" width="2" height="16" fill={color}>
        <animate
          attributeName="height"
          values="16;0;16"
          dur="1.5s"
          begin="0.15s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          values="4;12;4"
          dur="1.5s"
          begin="0.15s"
          repeatCount="indefinite"
        />
      </rect>

      {/* Bar 3 - animates after bar 2 */}
      <rect x="10" y="3" width="2" height="18" fill={color}>
        <animate
          attributeName="height"
          values="18;0;18"
          dur="1.5s"
          begin="0.3s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          values="3;12;3"
          dur="1.5s"
          begin="0.3s"
          repeatCount="indefinite"
        />
      </rect>

      {/* Bar 4 - animates after bar 3 */}
      <rect x="14" y="5" width="2" height="14" fill={color}>
        <animate
          attributeName="height"
          values="14;0;14"
          dur="1.5s"
          begin="0.45s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          values="5;12;5"
          dur="1.5s"
          begin="0.45s"
          repeatCount="indefinite"
        />
      </rect>

      {/* Bar 5 - animates after bar 4 */}
      <rect x="18" y="6" width="2" height="12" fill={color}>
        <animate
          attributeName="height"
          values="12;0;12"
          dur="1.5s"
          begin="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="y"
          values="6;12;6"
          dur="1.5s"
          begin="0.6s"
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  );
};

export default AudioWaveLoadingIcon;
